<template>
  <div>
    <component :is="linkConfig.element" v-bind="linkConfig.attrs">
      <picture>
        <img :src="lexasImage(productTileBannerImageUrl, 600)" :alt="altText" loading="lazy">
      </picture>
    </component>
  </div>
</template>

<script setup>
import { lexasImage } from '~/helpers/lexasImage'
import { useLexas } from '~/composables/useLexas'

const { getCategoryProductTile } = useLexas()

const { mobileImageData } = await getCategoryProductTile()

const productTileBannerImageUrl = computed(() => mobileImageData?.url || '')
const link = computed(() => mobileImageData?.linkData || '')
const altText = computed(() => mobileImageData?.altText || '')

const isExternal = computed(() => /^(http|https):\/\//.test(link.value))
const NuxtLink = resolveComponent('NuxtLink')

const linkConfig = computed(() => {
  return link.value
    ? isExternal.value
    // If the link is external, use an anchor link
      ? { element: 'a', attrs: { href: link.value, target: '_blank', rel: 'noopener noreferrer' } }
      // If the link is internal, use NuxtLink
      : { element: NuxtLink, attrs: { to: link.value } }
  // If there is no link, use a div element
    : { element: 'div', attrs: {} }
})
</script>
